/* ------------------------ Functional imports start ------------------------ */
import { createContext, useContext } from 'react'
import { type TImageEditorContext } from './utils/types'
/* ------------------------- Functional imports end ------------------------- */

export const ImageEditorContext = createContext<TImageEditorContext | undefined>(undefined)

export function useImageEditorContext(): TImageEditorContext {
  /* ------------------------- Non state data start ------------------------- */
  const context: TImageEditorContext | undefined = useContext(ImageEditorContext)
  /* -------------------------- Non state data end -------------------------- */

  // Context validation start
  if (!context) throw new Error(
    'useImageEditorContext must be used within an ImageEditorContextProvider.'
  )
  if(!context.image) throw new Error(
    'ImageEditorContextProvider must be provided with an image object.'
  )
  if(!context.shapes) throw new Error(
    'ImageEditorContextProvider must be provided with a shapes object.'
  )
  if(!context.createRectangle) throw new Error(
    'ImageEditorContextProvider must be provided with a createRectangle function.'
  )
  if(!context.createCircle) throw new Error(
    'ImageEditorContextProvider must be provided with a createRectangle function.'
  )

  return context
}